import React, { useEffect } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Home from '../pages/home';
import SideNav from '../components/side-nav';
import ErrorPage from '../pages/error';
import { errorMessages } from './error-messages';
import { AppState } from '../store';
import { navListAuthBased, NavSection } from './nav-list';
import Loading from '../pages/loading';
import UniversalModal from '../components/universal-modal';
import HomingService from '../components/homing-service';
import { useMountEffect } from './hooks/use-mount-effect';
import {
  getCustomUserPreferences,
  getGlobalUserPreferences,
} from '../store/user-preferences-v2/actions';
import { getEntitlementAuthorizations, updateLastLoginUser, getUserRole } from '../store/entitlements/actions';
import AppSettings from '../pages/app-settings';
import RestrictedAccess from '../pages/restricted-access';

const { location } = window;

const savedPath = window.localStorage.getItem('saved-path');
const savedSearch = window.localStorage.getItem('saved-search');

const Routes = () => {
  const dispatch = useDispatch();

  const appPermissions = useSelector(
    (state: AppState) => state.entitlements?.authorizations?.appPermissions,
  );
  const { client } = useSelector((state: AppState) => state.login);

  const loadingEntitlements = useSelector((state: AppState) => state.entitlements.loading);
  const entitlementsError = useSelector((state: AppState) => state.entitlements.error);

  useMountEffect(() => {
    const pathName = location.pathname;
    if (pathName !== '/redirect' && pathName !== '/') {
      localStorage.setItem('saved-path', pathName);
      localStorage.setItem('saved-search', location.search);
    }
  });

  useEffect(() => {
    if (client) {
      dispatch(updateLastLoginUser());
      dispatch(getGlobalUserPreferences());
      dispatch(getCustomUserPreferences());
      dispatch(getEntitlementAuthorizations());
      dispatch(getUserRole());
    }
  }, [dispatch, client]);

  const navList: NavSection | null = navListAuthBased(appPermissions);

  if (navList)
    return (
      <Router>
        <Switch>
          <Route
            path="/:page?/:deviceId?"
            component={() => (
              <SideNav navList={navList}>
                <HomingService navList={navList} />
                <UniversalModal />
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route exact path="/app-settings" component={AppSettings} />
                  <Route exact path="/redirect">
                    <Redirect
                      to={{
                        pathname: savedPath || '/',
                        search: savedSearch || '',
                      }}
                    />
                  </Route>
                  {Object.entries(navList).map(([key, navItem]) => (
                    <Route
                      key={`${navItem}-${key}`}
                      path={navItem.path}
                      component={navItem.component}
                    />
                  ))}
                  <Route
                    component={() => (
                      <ErrorPage
                        heading={errorMessages.fourZeroFour.heading}
                        description={errorMessages.fourZeroFour.description}
                      />
                    )}
                  />
                </Switch>
              </SideNav>
            )}
          />
        </Switch>
      </Router>
    );
  return (
    <>
      {loadingEntitlements && <Loading />}
      {!loadingEntitlements && entitlementsError && (
        <RestrictedAccess />
      )}
    </>
  );
};

export default Routes;
